import React, { useState, useRef } from "react";
import {
  Grid,
  TextField,
  DataGrid,
  Autocomplete,
  CircularProgress,
  Button,
  FormControl,
  CurrencyInput,
} from "../../../../../components";
import {
  EnderecoService,
  notification,
  NfSaidaService,
  MdfeService,
  MdfeNfsSaidaService,
} from "../../../../../services";
import {
  responseErros,
  formatPrice,
  unformatPrice,
} from "../../../../../utils";
import { value, InputErros } from "../../../../../helpers";
import shortid from "shortid";

const enderecoService = new EnderecoService();
const nfSaidaService = new NfSaidaService();
const mdfeService = new MdfeService();
const mdfeNfsSaidaService = new MdfeNfsSaidaService();

export default function TabDocumentosFiscaisEletronicos({
  estados,
  nfsSaida,
  setNfsSaida,
  id,
  setLoading,
  montarNfsSaidas,
  status,
  calcularTotaisNfsSaida,
  calcularValorTotalNfSaida,
}) {
  const [cidades, setCidades] = useState([]);
  const [estado, setEstado] = useState(null);
  const [nfSaidaMdfe, setNfSaidaMdfe] = useState({});
  const [cidade, setCidade] = useState(null);
  const [nfSaida, setNfSaida] = useState(null);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [listaNfSaida, setListaNfSaida] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const inputNfSaida = useRef();

  const nfsSaidaColunas = [
    {
      field: "codigoNfSaida",
      headerName: "Codigo",
      flex: 200,
      valueGetter: (params) => params.value || params.row.chaveDfe,
    },
    {
      field: "pesoTotal",
      headerName: "Peso Total",
      flex: 150,
    },
    {
      field: "valorTotal",
      headerName: "Valor Total",
      flex: 150,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "uf",
      headerName: "UF Descargar",
      flex: 150,
    },
    {
      field: "nome",
      headerName: "Cidade Descargar",
      flex: 200,
    },
  ];

  const changeCidadesByEstadoId = async (id) => {
    if (id) {
      enderecoService.getCidades(id).then((response) => {
        if (!response.isAxiosError) {
          if (!response.data) {
            notification.erroValidacao("Preencha um estado");
          } else {
            setCidades(response.data);
          }
        } else {
          responseErros(response);
        }
      });
    }
  };

  const onChangeEstado = async (newValue) => {
    setEstado(newValue || null);
    setCidade(null);
    if (newValue?.id) {
      changeCidadesByEstadoId(newValue.id);
    }
  };

  const onChangeCidade = (newValue) => {
    setCidade(newValue || null);
  };

  async function buscarNfsSaida(filter) {
    const result = await nfSaidaService.getAll(filter);
    if (!result.isAxiosError) {
      setListaNfSaida(result.data.rows);
    } else {
      responseErros(result);
    }
  }

  const onSearchChangeNfSaida = async (event, inputRef) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = {
        numeroDocumento: event.target?.value,
        status: "ENVIADA",
        restritiva: true,
      };
      setLoadingAutoComplete(true);
      await buscarNfsSaida(filtros);
      setLoadingAutoComplete(false);
    }
  };

  const onChangeAutocompleteNfSaida = (value) => {
    if (value) {
      setNfSaida(value);
      setNfSaidaMdfe({
        ...nfSaidaMdfe,
        valorTotal: null,
        chaveDfe: null,
      });
    }
  };

  const handleInputChange = (e) => {
    setInputErro([]);
    const nfsSaidaMdfeTemp = {
      ...nfSaidaMdfe,
      [e.target.name]: e.target.value,
    };
    setNfSaidaMdfe(nfsSaidaMdfeTemp);
  };

  function validarCamposObrigatorios() {
    inputErros.limpar();
    const erros = [];
    let mensagem = null;
    if (!nfSaida && !nfSaidaMdfe.chaveDfe) {
      erros.push("nfSaida");
      mensagem = "Nf de Saida";
    }
    if (!nfSaidaMdfe.valorTotal && nfSaidaMdfe.chaveDfe) {
      erros.push("valorTotal");
      mensagem = "Valor Total";
    }
    if (!nfSaidaMdfe.pesoTotal) {
      erros.push("pesoTotal");
      if (!mensagem) {
        mensagem = "Peso Total";
      }
    }
    if (!cidade) {
      erros.push("cidade");
      if (!mensagem) {
        mensagem = "Cidade Descarregamento";
      }
    }
    if (!estado) {
      erros.push("estado");
      if (!mensagem) {
        mensagem = "Estado Descarregamento";
      }
    }
    return {
      erros,
      mensagem,
    };
  }

  const onClickAdicionarNfSaida = () => {
    const validacao = validarCamposObrigatorios();
    if (validacao.erros.length) {
      return inputErros.gerar(validacao.erros, validacao.mensagem);
    }
    const nfSaidaAdicao = {
      id: shortid.generate(),
      codigoNfSaida: nfSaida?.numeroDocumento,
      fatNfSaidaId: nfSaida?.id,
      cidadeId: cidade.id,
      uf: cidade.estado.sigla,
      codigo: cidade.codigoIbge,
      nome: cidade.nome,
      pesoTotal: nfSaidaMdfe.pesoTotal,
      valorTotal: nfSaida?.id
        ? calcularValorTotalNfSaida(nfSaida)
        : nfSaidaMdfe?.valorTotal,
      chaveDfe: nfSaidaMdfe?.chaveDfe || nfSaida.chaveAcesso,
    };
    if (id) {
      cadastrarNfSaida(nfSaidaAdicao);
    } else {
      const nfsSaidaTemp = [...nfsSaida, nfSaidaAdicao];
      setNfsSaida(nfsSaidaTemp);
      calcularTotaisNfsSaida(nfsSaidaTemp);
    }
    setEstado(null);
    setCidade(null);
    setNfSaidaMdfe({});
    setCidades([]);
    setListaNfSaida([]);
    setNfSaida(null);
  };

  async function cadastrarNfSaida(nfSaidaAdicao) {
    setLoading(true);
    const response = await mdfeService.cadastrarNfSaida(id, nfSaidaAdicao);
    if (!response.isAxiosError) {
      await buscarNfsSaidaMdfe();
      setLoading(false);
      notification.cadastroSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  async function buscarNfsSaidaMdfe() {
    const filter = {
      fatMdfeId: id,
      nonPaginated: true,
    };
    const response = await mdfeNfsSaidaService.getAll(filter);
    if (!response.isAxiosError) {
      montarNfsSaidas(response.data);
    } else {
      responseErros(response);
    }
  }

  async function deletarMdfNfSaida(idMdfeNfSaida) {
    setLoading(true);
    const response = await mdfeNfsSaidaService.deletar(idMdfeNfSaida);
    if (!response.isAxiosError) {
      await buscarNfsSaidaMdfe();
      setLoading(false);
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  const onclickDeletar = (idMdfeNfSaida) => {
    if (id) {
      deletarMdfNfSaida(idMdfeNfSaida);
    } else {
      const nfsSaidaTemp = nfsSaida.filter(
        (nfSaidaMdfe) => nfSaidaMdfe.id != idMdfeNfSaida
      );
      calcularTotaisNfsSaida(nfsSaidaTemp);
      setNfsSaida(nfsSaidaTemp);
    }
  };

  const handleInputBlur = (event) => {
    const valor = parseFloat(unformatPrice(event.target.value));
    setNfSaidaMdfe({
      ...nfSaidaMdfe,
      [event.target.name]: valor || null,
    });
  };

  return (
    <Grid container spacing={2} alignItems="center" className="mt-2">
      <Grid item xs={3}>
        <Autocomplete
          id="nfSaida"
          name="nfSaida"
          options={listaNfSaida}
          autoHighlight
          getOptionLabel={(option) =>
            `Numero Documento: ${option?.numeroDocumento}`
          }
          loading={loadingAutoComplete}
          loadingText="Carregando"
          noOptionsText={
            document.getElementById("nfsaida")?.value.length >= 1 ? (
              <Grid container spacing={1}>
                <Grid item xs={12} fullWidth>
                  Nenhum NF de saida encontrado
                </Grid>
              </Grid>
            ) : (
              "Digite e pressione Enter"
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="NF de Saida"
              variant={"outlined"}
              margin="normal"
              onKeyDown={(e) => onSearchChangeNfSaida(e, inputNfSaida)}
              inputRef={inputNfSaida}
              error={inputErros.get("nfSaida")}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loadingAutoComplete ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          onChange={(_, newValue) => onChangeAutocompleteNfSaida(newValue)}
          value={nfSaida}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          id="chaveDfe"
          name="chaveDfe"
          label="Chave DF-e"
          error={inputErros.get("chaveDfe")}
          type="text"
          margin="normal"
          onChange={handleInputChange}
          fullWidth
          disabled={nfSaida}
          variant={nfSaida ? "filled" : "outlined"}
          value={value.text(nfSaidaMdfe?.chaveDfe)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          id="pesoTotal"
          name="pesoTotal"
          label="Peso Total"
          error={inputErros.get("pesoTotal")}
          type="number"
          margin="normal"
          onChange={handleInputChange}
          fullWidth
          value={value.text(nfSaidaMdfe?.pesoTotal)}
        />
      </Grid>
      <Grid item xs={2}>
        <CurrencyInput
          id="valorTotal"
          name="valorTotal"
          label="Valor Total"
          error={inputErros.get("valorTotal")}
          value={value.text(nfSaidaMdfe?.valorTotal)}
          variant={nfSaida ? "filled" : "outlined"}
          disabled={nfSaida}
          onBlur={handleInputBlur}
        />
      </Grid>
      <Grid item xs={3}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            required
            id="estado"
            name="estado"
            options={estados}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) =>
              option.sigla && option.nome
                ? `${option.sigla} - ${option.nome}`
                : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Estado Descarregamento"
                variant="outlined"
                error={inputErros.get("estado")}
              />
            )}
            onChange={(event, newValue) => onChangeEstado(newValue)}
            value={estado}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            required
            id="cidade"
            name="cidade"
            options={cidades}
            noOptionsText="Sem opções"
            autoHighlight
            disabled={!estado ? true : false}
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Cidade Descarregamento"
                variant="outlined"
                error={inputErros.get("cidade")}
              />
            )}
            onChange={(event, newValue) => {
              onChangeCidade(newValue);
            }}
            value={cidade}
          />
        </FormControl>
      </Grid>
      <Grid item xs={1}>
        <Button
          id="buttonAdicionar"
          variant="contained"
          color="success"
          size="small"
          disabled={status != "PENDENTE" ? true : false}
          sx={{
            height: "35px",
            borderRadius: "50%",
            minWidth: "15px",
            boxShadow: "none",
          }}
          onClick={onClickAdicionarNfSaida}
        >
          <i
            className="ph-bold ph-plus"
            style={{ color: "#fff", fontSize: 15 }}
          ></i>
        </Button>
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          style={{ zIndex: 1 }}
          rows={nfsSaida}
          columns={nfsSaidaColunas}
          rowCount={nfsSaida.length}
          onClickDelete={onclickDeletar}
          deleteShow={status != "PENDENTE" ? false : true}
        />
      </Grid>
    </Grid>
  );
}
